import { resolveId } from '@medplum/core'
import type { Patient, Reference } from '@medplum/fhirtypes'
import { referenceDisplay } from '@seen/core/display'
import { Participant } from '@seen/core/models/patients/participant'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'
import { Link } from '#src/components/core/Link.tsx'
import { RowBadge } from '#src/components/TaskRowBadge.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ParticipantTaskRowBadge({
  participant,
  className,
}: {
  participant: Reference<Patient>
  className?: string
}): JSX.Element {
  const { data: instance } = useRead(Participant, participant)
  return (
    <Link
      to={instance?.relativeUrl ?? `/Patient/${resolveId(participant)}`}
      className={cn('flex', className)}
    >
      <RowBadge icon={<Avatar profile={participant} size={3.5} />}>
        {instance?.name ?? referenceDisplay(participant)}
      </RowBadge>
    </Link>
  )
}
